import { StyleSheet } from "aphrodite";

const styles = StyleSheet.create({
  mainGrid: {
    padding: "0px",
    margin: "0px",
    width: "100%",
  },
  secondGrid: {
    padding: "0px",
    margin: "0px !important",
    width: "100%",
    "@media (max-width: 767.98px)": {
      paddingBottom: "0.5rem",
    },
  },
  sideStyle: {
    //borderRightWidth: "20px",
    //borderRightStyle: "solid",
    //borderImage: "linear-gradient(#2156a4, #32a6c4e3) 30",
    background: "rgb(0 179 250)",
    fontSize: "18px",
    //fontWeight: "500",
    height: "75vh",
    //width: "250px",
    //position: "absolute",
    transition: "all 0.25s ease",
    padding: "0px",
  },
  navStyle: {
    padding: "20px",
    color: "#fff",
    display: "block",
    textDecoration: "none",
    borderBottom: "1px solid #fff",
    ":hover": {
      opacity: "0.8",
      transition: "all 0.25s ease",
      background: "#000",
      cursor: "pointer",
    },
  },

  //right div styles

  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "2px solid #76787a",
    paddingBottom: "10px",
    margin: "10px 0px 10px 0px",
    color: "#76787a",
    fontSize: "16px",
  },
  labels: {
    fontSize: "16px",
    //color: "#76787a",
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  valueLabels: {
    fontSize: "14px",
    marginLeft: "0.8em",
    fontWeight: 900,
  },
  cardHeaderStyle: {
    padding: "5px 10px",
    fontSize: "14px",
    backgroundColor: "#aeaeae54",
    fontWeight: 900,
  },
  cardBody: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  cardBodyTitle: {
    fontSize: "16px",
  },
  cardBodyText: {
    fontSize: "14px",
  },
  profile: {
    height: "60px",
    width: "60px",
    borderRadius: "50%",
    //objectFit: "contain",
    //border: "1px solid gray",
  },
  textFieldClass: {
    borderRadius: "5px",
    border: "1px solid #808488",
    width: "100%",
  },
  textAreaClass: {
    borderRadius: "10px",
    border: "1px solid #808488",
    resize: "none",
    width: "100%",
  },
  subsTextAreaClass: {
    borderRadius: "0px",
    border: "1px solid #808488",
    resize: "none",
    width: "100%",
  },
  buttonClass: {
    borderRadius: "20px",
    width: "20%",
    minWidth: "120px",
    "@media (max-width: 767.98px)": {
      width: "100%",
      maxWidth: "280px",
    },
  },
  phoneInputClass: {
    width: "100%",
  },
});

export default styles;
